const AuthRoutes = [
{
	name: 'login',
	path: 'login',
	component: () => import('@/components/auth/login/Login.vue'),
},
{
	path: '',
	redirect: { name: 'login' },
},
]

export default AuthRoutes;